import React from 'react'
import styled from 'styled-components'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Modal from 'components/Modal'
import { CONFIRMATION_DIALOG_MESSAGES } from 'helpers/confirmationDialogMessages'

interface Props {
  isOpen: boolean
  title?: string
  description: React.ReactNode
  confirmText?: string
  cancelText?: string
  onCancel: () => void
  onConfirm: () => void
}

const ConfirmDialog = ({
  isOpen,
  title,
  description,
  confirmText = CONFIRMATION_DIALOG_MESSAGES.BUTTON_TEXT.OK,
  cancelText = CONFIRMATION_DIALOG_MESSAGES.BUTTON_TEXT.CANCEL,
  onCancel,
  onConfirm
}: Props) => {
  return (
    <Modal
      variant="sm"
      fullWidth
      title={title}
      isDisplayed={isOpen}
      closeCallback={onCancel}
    >
      {description}
      <S.ButtonContainer>
        <Button decoration="secondary" text={cancelText} onPress={onCancel} />
        <Button decoration="positive" text={confirmText} onPress={onConfirm} />
      </S.ButtonContainer>
    </Modal>
  )
}

export default ConfirmDialog

const S = {
  ButtonContainer: styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  `
}
